<template>
    <div class="preEducationAlone">
        <div class="tabel-box">
            <div style="display: flex;justify-content: space-between;">
                <div style="font-size: 18px;font-weight: bold;margin-bottom: 10px;">前置学历复查</div>
                <div>
                    <el-button class="exit-btn" type="primary" @click="exit">退出登录</el-button>
                </div>
            </div>
            <div class="tips">
                <div class="title">请上传以下三类材料之一的照片</div>
                <div class="template">
                    <div class="template-item">
                        <el-image 
                            class="img" 
                            :src="require('../../../assets/images/preEducation/template1.png')" 
                            fit="contain"
                            :preview-src-list="
                                [
                                    require('../../../assets/images/preEducation/template1.png'), 
                                    require('../../../assets/images/preEducation/template2.jpg'),
                                    require('../../../assets/images/preEducation/template3.png')
                                ]
                            ">
                        </el-image>
                        <p class="text">教育部学历证书电子注册备案表</p>
                    </div>
                    <div class="template-item">
                        <el-image 
                            class="img" 
                            :src="require('../../../assets/images/preEducation/template2.jpg')" 
                            fit="contain"
                            :preview-src-list="
                                [
                                    require('../../../assets/images/preEducation/template1.png'), 
                                    require('../../../assets/images/preEducation/template2.jpg'),
                                    require('../../../assets/images/preEducation/template3.png')
                                ]
                            ">
                        </el-image>
                        <p class="text">教育部学历证书电子注册备案表</p>
                    </div>
                    <div class="template-item">
                        <el-image 
                            class="img" 
                            :src="require('../../../assets/images/preEducation/template3.png')" 
                            fit="contain"
                            :preview-src-list="
                                [
                                    require('../../../assets/images/preEducation/template1.png'), 
                                    require('../../../assets/images/preEducation/template2.jpg'),
                                    require('../../../assets/images/preEducation/template3.png')
                                ]
                            ">
                        </el-image>
                        <p class="text">教育部学历证书电子注册备案表</p>
                    </div>
                </div>
            </div>
            <el-table
                :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
                :data="tableData"
                border
                style="width: 100%;margin-top: 20px;"
            >
                <el-table-column prop="review_status" label="复查状态" align="center">
                    <template v-slot="{row}">
                        <el-tag :type="row.review_status | reviewStatusStyle">
                            {{ row.review_status | reviewStatusFilter }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="title" label="资料照片" align="center">
                    <template v-slot="{row}">
                        <!-- <img v-if="row.means_photo !== ''" class="see-img" :src="row.means_photo" alt="" @click="seeImg(row.means_photo)"> -->
                        <el-image 
                            v-if="row.means_photo ? true : false"
                            class="see-img"
                            :src="row.means_photo" 
                            fit="contain"
                            :preview-src-list="[row.means_photo]">
                        </el-image>
                        <el-upload 
                            v-else 
                            class="upload-demo" 
                            action="" 
                            :http-request="upLoadImg" 
                            :show-file-list="false">
                            <el-button type="primary" size="small">上传资料照片</el-button>
                        </el-upload>
                    </template>
                </el-table-column>
                <el-table-column prop="review_remark" align="center" label="复查原因"></el-table-column>
                <el-table-column prop="is_check" align="center" label="审核状态">
                    <template slot-scope="{ row }">
                        <el-tag :type="row.is_check | isCheckStyle">
                            {{ row.is_check | isCheckFilter }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="check_user_title" align="center" label="审核人"></el-table-column>
                <el-table-column prop="check_at" align="center" label="审核时间"></el-table-column>
                <el-table-column prop="check_remark" align="center" label="审核备注"></el-table-column>
            </el-table>
        </div>
        <!-- 查看图片弹窗 -->
        <div class="seeImage">
            <el-dialog :visible.sync="seeImageVisible">
                <div class="img-box">
                    <img :src="seeImageUrl" alt="" style="width: 500px;">
                </div>
                <div class="btn-box">
                    <el-upload 
                        class="upload-demo" 
                        action="" 
                        :http-request="upLoadImg" 
                        :show-file-list="false">
                        <el-button type="primary">修改资料照片</el-button>
                    </el-upload>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import {userPreReview, upMeansPhoto} from '@/api/basic';
import {putObject} from '@/utils/upload';
import {isAssetTypeAnImage} from '@/utils/func';
export default {
    name: 'preEducationAlone',
    filters: {
        // 复查状态
        reviewStatusFilter(v){
            let obj = {
                0: '未处理', 
                1: '已处理', 
            };
            return obj[v];
        },
        // 复查状态 样式
        reviewStatusStyle(v){
            let obj = {
                0: '', 
                1: 'success',
            };
            return obj[v];
        },
        // 审核状态
        isCheckFilter(v){
            let obj = {
                0: '待审核',
                1: '已通过', 
                2: '未通过',
            };
            return obj[v];
        },
        // 审核状态 样式
        isCheckStyle(v){
            let obj = {
                0: '', 
                1: 'success', 
                2: 'danger', 
            };
            return obj[v];
        },
    },
    data(){
        return {
            tableData: [
                // {
                //     review_status: 0,
                //     means_photo: 'https://cqjtdx.shoss.xstore.ctyun.cn/student/2022-5/1653447590410.jpg',
                // }
            ],

            //图片放大查看
            seeImageVisible: false, 
            seeImageUrl: '',
        };
    },
    created(){
        this.getData();
    },
    methods: {
        // 退出
        async exit() {
            // loginOut(null).then(() => {
            // this.$store.dispatch('permission/setIsGenerateRoutes', '');
            await this.$store.dispatch('permission/logOut');
            // Cookies.remove('token');
            this.$message.success('退出成功');
            this.$router.replace("/Login");

            // });
        },
        // 上传资料照片
        upLoadImg(file){
            let type = file.file.name.split('.')[file.file.name.split('.').length - 1];

            let isImg = isAssetTypeAnImage(type);

            if (!isImg) {
                this.$message.error('文件类型不正确，请选择图片格式的文件');
                return;
            }

            putObject(file, async url => {
                if (url) {
                    // const str = url.split('.zip')[0];
                    const params = {
                        means_photo: url
                    };
                    let res = await upMeansPhoto(params);
                    if (res.code == 200) {
                        this.$message.success('上传成功');
                        this.seeImageVisible = false;
                        this.getData();
                    }
                }
            }, null, 'student', type );
        },
        // 获取数据
        async getData(){
            let res = await userPreReview();
            if(res.code == 200){
                let {result} = res;
                this.tableData = result;
            }
        },
        //图片 点击放大
        seeImg(img){
            this.seeImageVisible = true;
            this.seeImageUrl = img;
        },
    },
};
</script>

<style lang="scss" scoped>
.preEducationAlone{
    // min-height: $contentH;
    min-height: calc(100vh - 40px);
    padding: 20px;
    padding-bottom: 0;
    .submitBtn{
        text-align: right;
    }
    .tabel-box{
        min-height: inherit;
        border-radius: 5px;
        background-color: #ffffff;
        overflow: hidden;
        padding: 30px 30px 0;
        .tips{
            .template{
                display: flex;
                .template-item{
                    padding: 10px;
                    width: 220px;
                    margin: 0 10px;
                    .img{
                        height: 200px;
                    }
                    .text{
                        text-align: center;
                    }
                }
            }
        }
    }
    .see-img{
        width: 40px;
        object-fit: contain;
        cursor: pointer;
    }
}
</style>

<style lang="scss">
.preEducation{
    .seeImage{
        .el-dialog{
            width: 600px;
            .img-box{
                display: flex;
                justify-content: center;
            }
            .btn-box{
                margin-top: 10px;
                padding-left: 24px;
            }
        }
    }
}
</style>